<div class="fullscreen-container">

    <div class="terminal-container">
        <div class="terminal-class" #myTerminal></div>
    </div>


</div>